import React from 'react';

interface StartFlikButtonProps {
  emails?: string[];
  onSuccess?: () => void;
  onClick?: () => void;
  className?: string;
}

const StartFlikButton: React.FC<StartFlikButtonProps> = ({ 
  emails = [], 
  onSuccess, 
  onClick, 
  className = '' 
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      // Default behavior - start Flik session
      console.log('Starting Flik session with emails:', emails);
      if (onSuccess) {
        onSuccess();
      }
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors ${className}`}
    >
      Start Flik
    </button>
  );
};

export { StartFlikButton };
